import Vue from 'vue'
import VueRouter from 'vue-router'
import PointsPage from '@/components/pages/PointsPage'
import MessagesPage from '@/components/pages/MessagesPage'
import CustomPage from '@/components/pages/CustomPage'
import ProfilePage from '@/components/pages/ProfilePage'
import AgreementsPage from '@/components/pages/AgreementsPage'
import ChangePasswordPage from '@/components/pages/ChangePasswordPage'
import ChangeEmailPage from '@/components/pages/ChangeEmailPage'
import PrivacyPolicyPage from '@/components/pages/PrivacyPolicyPage'
import RewardsPage from '@/components/pages/RewardsPage'
import ReceivedRewardsPage from '@/components/pages/ReceivedRewardsPage'
import store from '@/store'
import CreatePasswordPage from '@/components/pages/CreatePasswordPage'
import axios from '@/axios'
import Wrapper from "@/components/pages/Wrapper";
import AttachmentsPage from "../components/pages/AttachmentsPage";
import GoalsPage from "../components/pages/GoalsPage";
import QuizzesPage from "../components/pages/QuizzesPage";
import QuizPage from "../components/pages/QuizPage";
import EmptyPage from "../components/pages/EmptyPage";
import RankingPage from "@/components/pages/RankingPage";
import LoginPage from "@/components/pages/LoginPage";
import SignInPage from "@/components/pages/SignInPage";
import SignUpPage from "@/components/pages/SignUpPage";
import SetPasswordPage from "@/components/pages/SetPasswordPage";
import ForgotPasswordPage from "@/components/pages/ForgotPasswordPage";
import ExternalPage from "@/components/pages/ExternalPage";
import {isPwa} from "@/utils/Pwa";
import SurveysPage from "@/components/pages/SurveysPage";
import PollsPage from "@/components/pages/PollsPage";
import RewardsByCategoryPage from "@/components/pages/RewardsByCategoryPage.vue";
import CategoryPage from "@/components/pages/CategoryPage.vue";

Vue.use(VueRouter);

const isDefaultLocation = window.location.href.includes(process.env.VUE_APP_MODULE_DEFAULT_DOMAIN);

const router = new VueRouter({
  routes: [
    {
      path: isDefaultLocation ? '/:uuid' : '',
      component: Wrapper,
      children: [
        {
          path: '',
          redirect: 'login',
        },
        {
          path: 'login',
          name: 'Login',
          component: LoginPage,
        },
        {
          path: 'login/ref/:referrer',
          name: 'LoginReferrer',
          component: LoginPage
        },
        {
          path: 'sign-in',
          name: 'SignIn',
          component: SignInPage,
        },
        {
          path: 'sign-up',
          name: 'SignUp',
          component: SignUpPage,
        },
        {
          path: 'password/set',
          name: 'SetPassword',
          component: SetPasswordPage,
        },
        {
          path: 'password/create/:token',
          name: 'CreatePassword',
          component: CreatePasswordPage
        },
        {
          path: 'password/forgot',
          name: 'ForgotPassword',
          component: ForgotPasswordPage
        },
        {
          path: 'external',
          name: 'ExternalPage',
          component: ExternalPage
        },
        {
          path: 'points',
          name: 'PointsPage',
          component: PointsPage
        },
        {
          path: 'messages',
          name: 'MessagesPage',
          component: MessagesPage
        },
        {
          path: 'rewards/received',
          name: 'ReceivedRewardsPage',
          component: ReceivedRewardsPage
        },
        {
          path: 'rewards',
          component: EmptyPage,
          children: [
            {
              path: '',
              name: 'RewardsPage',
              component: RewardsPage,
            },
            {
              path: ':id',
              name: 'RewardsByCategoryPage',
              component: RewardsByCategoryPage,
            }
          ]
        },
        {
          path: 'ranking',
          name: 'RankingPage',
          component: RankingPage
        },
        {
          path: 'goals',
          name: 'GoalsPage',
          component: GoalsPage,
        },
        {
          path: 'quizzes',
          component: EmptyPage,
          children: [
            {
              path: '',
              name: 'QuizzesPage',
              component: QuizzesPage
            },
            {
              path: ':id',
              name: 'QuizPage',
              component: QuizPage
            },
          ],
        },
        {
          path: 'polls',
          component: EmptyPage,
          children: [
            {
              path: '',
              name: 'PollsPage',
              component: PollsPage
            },
            {
              path: ':id',
              name: 'PollPage',
              component: QuizPage
            },
          ],
        },
        {
          path: 'surveys',
          name: 'SurveysPage',
          component: SurveysPage,
        },
        {
          path: 'page/:pageUuid',
          name: 'CustomPage',
          component: CustomPage
        },
        {
          path: 'pagecategory/:categoryUuid',
          name: 'CategoryPage',
          component: CategoryPage
        },
        {
          path: 'profile',
          name: 'ProfilePage',
          component: ProfilePage,
        },
        {
          path: 'profile/agreements',
          name: 'AgreementsPage',
          component: AgreementsPage
        },
        {
          path: 'attachments',
          name: 'AttachmentsPage',
          component: AttachmentsPage
        },
        {
          path: 'profile/change-password',
          name: 'ChangePassword',
          component: ChangePasswordPage
        },
        {
          path: 'profile/change-email',
          name: 'ChangeEmail',
          component: ChangeEmailPage
        },
        {
          path: 'privacy-policy',
          name: 'PrivacyPolicyPage',
          component: PrivacyPolicyPage
        },
        {
          path: 'email/confirm/:token',
          redirect: to => {
            axios.patch(`email/confirm/${to.params.token}`)
              .then(() => {
                store.dispatch('logout')
              });
          }
        },
        {
          path: 'activate/:token',
          redirect: to => {
            axios.patch(`account/activate/${to.params.token}`, {
              pwa: isPwa
            })
              .then((r) => {
                if (r.data.success) {
                  setTimeout(() => store.dispatch('afterLoginSuccess', {
                    token: r.data.token,
                    user: r.data.user,
                    entity: r.data.entity,
                  }), 0);
                } else {
                  router.push({name: 'Login'})
                }
              });
          }
        },
        {
          path: 'activate/:token/ref/:referrer',
          redirect: to => {
            axios.patch(`account/activate/${to.params.token}/ref/${to.params.referrer}`, {
              pwa: isPwa
            })
              .then((r) => {
                if (r.data.success) {
                  setTimeout(() => store.dispatch('afterLoginSuccess', {
                    token: r.data.token,
                    user: r.data.user,
                    entity: r.data.entity,
                  }), 0);
                } else {
                  router.push({name: 'Login'})
                }
              });
          }
        },
        {
          path: '*',
          redirect: 'points'
        },
      ],
    },
    {
      path: '/redirect',
      beforeEnter() {
        window.location = 'https://loyaltystarter.io'
      }
    },
    {
      path: '*',
      redirect: '/redirect'
    }
  ],
  mode: 'history',
  base: isDefaultLocation ? '/member/' : '/'
});

router.beforeEach((to, from, next) => {
  if (isDefaultLocation && to.params.hasOwnProperty('uuid') && to.params.uuid.length !== 36) {
    window.location = 'https://loyaltystarter.io'
  }

  const uuidPathPart = isDefaultLocation ? `/${to.params.uuid}` : '';

  if (!store.state.auth.isAuthorized && to.params.hasOwnProperty('uuid') && isPrivate(to.path)) {
    next({
      path: `${uuidPathPart}/login`
    });
  } else {
    if (store.state.auth.isAuthorized && store.state.auth.user.missing_agreements.length && isAvailableWithMissingFields(to.path)) {
      next({
        path: `${uuidPathPart}/profile/agreements`
      });
    } else if (store.state.auth.isAuthorized && store.state.auth.user.missing_fields.length && isAvailableWithMissingFields(to.path)) {
      next({
        path: `${uuidPathPart}/profile`
      });
    } else {
      next();
    }
  }
});

const resourcesAvailableWithMissingFields = [
  '/profile',
  '/profile/agreements',
  '/profile/change-password',
  '/profile/change-email',
  '/privacy-policy'
];

function isAvailableWithMissingFields(path) {
  for (let i = 0; i < resourcesAvailableWithMissingFields.length; i++) {
    if (path.includes(resourcesAvailableWithMissingFields[i])) {
      return false;
    }
  }

  return true;
}

const publicResources = [
  '/login',
  '/sign-in',
  '/sign-up',
  '/password/set',
  '/password/create',
  '/password/forgot',
  '/email/confirm',
  '/activate',
  '/redirect',
  '/external',
  '/privacy-policy'
];

function isPrivate(path) {
  for (let i = 0; i < publicResources.length; i++) {
    if (path.includes(publicResources[i])) {
      return false;
    }
  }

  return true;
}

export default router;
